'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var initialize = exports.initialize = {
    errors: {
        initContextUndefined: {
            code: 201,
            desc: 'InitContext is not defined'
        },
        envUndefined: {
            code: 202,
            desc: 'Service endpoint environment is not defined'
        },
        clientIdUndefined: {
            code: 203,
            desc: 'Client id is not defined'
        },
        accessTokenUndefined: {
            code: 204,
            desc: 'Access token is not defined'
        },
        accessTokenInvalid: {
            code: 205,
            desc: 'Access token is not valid'
        },
        callbacksUndefined: {
            code: 206,
            desc: 'Essential callbacks are not defined'
        },
        onSuccessCallbackUndefined: {
            code: 207,
            desc: 'On success callback is not defined'
        },
        onFailureCallbackUndefined: {
            code: 208,
            desc: 'On failure callback is not defined'
        },
        onMessageCallbackUndefined: {
            code: 209,
            desc: 'On message callback is not defined'
        },
        onClientStateCallbackUndefined: {
            code: 210,
            desc: 'On client state callback is not defined'
        },
        environmentInvalid: {
            code: 211,
            desc: 'Service endpoint environment is not valid'
        },
        wamIsNotInitialized: {
            code: 212,
            desc: 'WAM is not initialized'
        }
    }
};

var thorConnection = exports.thorConnection = {
    errors: {
        thorNotPresent: {
            code: 101,
            desc: 'Creative cloud desktop is not present'
        },
        thorForWAMConnectionNotPresent: {
            code: 102,
            desc: 'Creative cloud desktop is not available to support WAM connection'
        },
        accessTokenInvalidOrExpired: {
            code: 103,
            desc: 'Access token is invalid or expired'
        },
        clientAndWAMConnectionTimeout: {
            code: 104,
            desc: 'Timeout occurs in connecting WAM from client'
        },
        clientFailedToRegisterAtWAM: {
            code: 105,
            desc: 'Client failed to register at WAM'
        },
        thorConnectionTimeout: {
            code: 106,
            desc: 'Timeout in making connection with Creative cloud desktop via WAM'
        },
        userMismatch: {
            code: 107,
            desc: 'User is mismatched between client and Creative cloud desktop'
        },
        default: {
            code: 100,
            desc: 'Unable to connect with Creative Cloud Desktop'
        }
    }
};
var command = exports.command = {
    errors: {
        cmdContextUndefined: {
            code: 301,
            desc: 'Command context is not defined'
        },
        sapcodeUndefined: {
            code: 302,
            desc: 'Sapcode is not defined in command context'
        },
        versionUndefined: {
            code: 303,
            desc: 'Version is not defined in command context'
        },
        confirmationIdUndefined: {
            code: 304,
            desc: 'Confirmation Id is not defined in confirmation command context'
        },
        confirmationTypeUndefined: {
            code: 305,
            desc: 'Confirmation type is not defined in confirmation command context'
        },
        commandPayloadUndefined: {
            code: 306,
            desc: 'Command payload is not defined'
        },
        commandUndefined: {
            code: 307,
            desc: 'Command is not defined'
        },
        currentDeviceNotFound: {
            code: 308,
            desc: 'Creative Cloud app\'s deviceId state not detected'
        },
        commandNotSupported: {
            code: 309,
            desc: 'Command is not supported. Supported commands are [\'install\', \'launch\', \'uninstall\', \'update\', \'retry\', \'cancel\']'
        }
    }
};